const DEFAULT_BRAND = "#E2601C";
const DEFAULT_DARK = "#C0501A";

function darken(hex, amount = 0.15) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return DEFAULT_DARK;
  const rgb = [1, 2, 3].map((i) => Math.max(0, Math.round(parseInt(m[i], 16) * (1 - amount))));
  return "#" + rgb.map((v) => v.toString(16).padStart(2, "0")).join("");
}

export function applyBrand(color) {
  const root = document.documentElement;
  root.style.setProperty("--brand", color || DEFAULT_BRAND);
  root.style.setProperty("--brand-dark", color ? darken(color) : DEFAULT_DARK);
}
